export default __webpack_public_path__ + "static/media/edit-icon.833deaf6.svg";